export default function Animations() {
  const animations = new Set();
  function tick(p) {
    Array.from(animations).forEach(animation => {
      if (!animation.tick(p)) remove(animation);
    });
  }
  function add(animation) {
    animations.add(animation);
  }
  function remove(animation) {
    animations.delete(animation);
  }
  return {
    add,
    tick
  };
}